var _circle, _circle2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedOops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#DFE2EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0002,
    cy: 43.9988,
    r: 26.6316,
    fill: "white",
    stroke: "#00193C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.609 33.5781H42.8421V45.1571H29.609L25.4736 39.3676L29.609 33.5781Z",
    fill: "#0E5CF4",
    stroke: "#00193C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3686 39.5392C39.0519 39.574 38.5716 39.5459 38.1496 39.284C38.0804 39.2411 37.983 39.2636 37.9396 39.3325C37.7819 39.5822 37.4598 39.9968 37.2834 40.1954C37.2325 40.2528 37.1482 40.2385 37.1114 40.1712L36.1319 38.3805C36.0884 38.3009 35.9749 38.2957 35.919 38.367C33.8948 40.9491 33.8869 38.5337 33.4739 40.0915C33.2206 41.0468 31.5089 40.2665 31.3113 39.3158C31.288 39.2035 31.134 39.1146 31.0363 39.1746C30.7853 39.3288 30.4359 39.5053 30.1055 39.5689",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4831 50.9453L45.1578 50.9453L45.1578 40.5243L59.4831 40.5243L63.6841 45.7348L59.4831 50.9453Z",
    fill: "#0E5CF4",
    stroke: "#00193C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1581 69.47V31.2595C45.1581 30.62 44.6397 30.1016 44.0002 30.1016V30.1016C43.3607 30.1016 42.8423 30.62 42.8423 31.2595V69.47",
    stroke: "#00193C",
    strokeWidth: 1.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8945 45.3283C57.5778 45.3631 57.0975 45.3349 56.6755 45.0731C56.6063 45.0301 56.5089 45.0527 56.4654 45.1215C56.3078 45.3713 55.9857 45.7859 55.8093 45.9845C55.7583 46.0419 55.6741 46.0276 55.6373 45.9602L54.6578 44.1695C54.6143 44.09 54.5008 44.0847 54.4449 44.1561C52.4207 46.7382 52.4128 44.3227 51.9998 45.8806C51.7465 46.8359 50.0347 46.0555 49.8372 45.1048C49.8139 44.9926 49.6599 44.9037 49.5622 44.9637C49.3111 45.1178 48.9618 45.2944 48.6313 45.3579",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedOops);
export default __webpack_public_path__ + "static/media/ic-shared-oops.e0fe0a18e774a4dc474d60583beb9cea.svg";
export { ForwardRef as ReactComponent };